import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import translations from '../../translations';
import SaudiRiyalIcon from '../../components/UI/SaudiRiyalIcon';
import './ProjectDetails.css';

// Import project images
import project1 from '../../assets/project1.webp';
import project2 from '../../assets/project2.webp';
import image28 from '../../assets/28.webp';
import image27 from '../../assets/27.webp';
import image26 from '../../assets/26.webp';
import image30 from '../../assets/30.webp';
import image29 from '../../assets/29.webp';
import image31 from '../../assets/31.webp';
import sharafat01 from '../../assets/شرفات 01.webp';
import sharafatAlNada from '../../assets/شرفات الندي.webp';
import image33 from '../../assets/33.webp';
import image32 from '../../assets/32.webp';
import image34 from '../../assets/34.webp';
import image37 from '../../assets/37.webp';
import image62 from '../../assets/62.webp';
import image63 from '../../assets/63.webp';
import Mishkat01 from '../../assets/Mishkat01.webp';
import Mishkat02 from '../../assets/Mishkat02.webp';
import Mishkat03 from '../../assets/Mishkat03.webp';
import Mosque01 from '../../assets/Mosque01.webp';
import Mosque02 from '../../assets/Mosque02.webp';
import Mosque03 from '../../assets/Mosque03.webp';
import image130 from '../../assets/IMG-20250319-WA0130.webp';
import image121 from '../../assets/IMG-20250319-WA0121.webp';
import image126 from '../../assets/IMG-20250319-WA0126.webp';
import image39 from '../../assets/39.webp';
import image42 from '../../assets/42.webp';
import image43 from '../../assets/43.webp';
import image44 from '../../assets/44.webp';
import image45 from '../../assets/45.webp';
import image49 from '../../assets/49 .webp';
import image50 from '../../assets/50.webp';
import image51 from '../../assets/51.webp';
import image55 from '../../assets/55.webp';
import image56 from '../../assets/56.webp';
import image57 from '../../assets/57.webp';
import image58 from '../../assets/58.webp';
import image52 from '../../assets/52.webp';
import image53 from '../../assets/53.webp';
import image54 from '../../assets/54.webp';
import image35adli from '../../assets/35 ADLI.webp';
import image37adli from '../../assets/37 ADLI.webp';
import image38adli from '../../assets/38 ADLI.webp';
import imageAdmin2 from '../../assets/admin2.webp';
import imageAdmin from '../../assets/admin.webp';
import image60 from '../../assets/60.webp';
import image59 from '../../assets/59.webp';
import image01 from '../../assets/01.webp';
import image47 from '../../assets/47.webp';
import image48 from '../../assets/48.webp';
import image46 from '../../assets/46.webp';

const ProjectDetails = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { language } = useLanguage();
  const t = translations[language];

  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  // Minimum swipe distance (in px)
  const minSwipeDistance = 50;

  const onTouchStart = (e) => {
    setTouchEnd(null); // otherwise the swipe is fired even with usual touch events
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;
    if (isLeftSwipe || isRightSwipe) {
      if (isLeftSwipe) {
        nextImage();
      } else {
        prevImage();
      }
    }
  };

  const nextImage = () => {
    if (project && project.gallery) {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === project.gallery.length - 1 ? 0 : prevIndex + 1
      );
    }
  };

  const prevImage = () => {
    if (project && project.gallery) {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === 0 ? project.gallery.length - 1 : prevIndex - 1
      );
    }
  };

  // Project data with imported images
  const projects = [
    {
      id: 1,
      slug: 'al-nada-sharafat',
      title: t.project1Title,
      description: t.project1Description,
      details: t.project1Details || 'Detailed information about this project will be available soon.',
      image: project1,
      area: '17,000 m²',
      cost: language === 'en' ? '25+ Million' : '٢٥+ مليون',
      gallery: [sharafat01, sharafatAlNada],
      features: [
        t.project1Feature1 || 'Feature 1',
        t.project1Feature2 || 'Feature 2',
        t.project1Feature3 || 'Feature 3'
      ]
    },
    {
      id: 2,
      slug: 'private-villa-project',
      title: t.project2Title,
      description: t.project2Description,
      details: t.project2Details || 'Detailed information about this project will be available soon.',
      image: project2,
      area: '120,000 m²',
      cost: language === 'en' ? '90+ Million' : '٩٠+ مليون',
      gallery: [project2, image37, image62, image63],
      features: [
        t.project2Feature1 || 'Feature 1',
        t.project2Feature2 || 'Feature 2',
        t.project2Feature3 || 'Feature 3'
      ]
    },
    {
      id: 3,
      slug: 'starta-villa-project',
      title: t.project3Title,
      description: t.project3Description,
      details: t.project3Details,
      image: image28,
      area: '11,700+ m²',
      cost: language === 'en' ? '13+ Million' : '١٣+ مليون',
      gallery: [image28, image27, image26],
      features: [
        t.project3Feature1 || 'Feature 1',
        t.project3Feature2 || 'Feature 2',
        t.project3Feature3 || 'Feature 3'
      ]
    },
    {
      id: 4,
      slug: 'al-ahsa-construction-station',
      title: t.project4Title,
      description: t.project4Description,
      details: t.project4Details || 'Detailed information about this project will be available soon.',
      image: image33,
      area: '2,100+ m²',
      cost: language === 'en' ? '3+ Million' : '٣+ مليون',
      gallery: [image33, image32, image34],
      features: [
        t.project4Feature1 || 'Feature 1',
        t.project4Feature2 || 'Feature 2',
        t.project4Feature3 || 'Feature 3'
      ]
    },
    {
      id: 5,
      slug: 'mishkah-association-project',
      title: t.project5Title,
      description: t.project5Description,
      details: t.project5Details,
      image: Mishkat01,
      area: '5,100+ m²',
      cost: language === 'en' ? '16+ Million' : '١٦+ مليون',
      gallery: [Mishkat01, Mishkat02, Mishkat03],
      features: [
        t.project5Feature1 || 'Feature 1',
        t.project5Feature2 || 'Feature 2',
        t.project5Feature3 || 'Feature 3'
      ]
    },
    {
      id: 6,
      slug: 'al-waqf-mosque-project',
      title: t.project6Title,
      description: t.project6Description,
      details: t.project6Details,
      image: Mosque01,
      area: '8,000 m²',
      cost: language === 'en' ? '12+ Million' : '١٢+ مليون',
      gallery: [Mosque01, Mosque02, Mosque03],
      features: [
        t.project6Feature1 || 'Feature 1',
        t.project6Feature2 || 'Feature 2',
        t.project6Feature3 || 'Feature 3'
      ]
    },
    {
      id: 7,
      slug: 'riwaq-al-madinah',
      title: t.project7Title,
      description: t.project7Description,
      details: t.project7Details,
      image: image30,
      area: '2,600+ m²',
      cost: language === 'en' ? '12+ Million' : '١٢+ مليون',
      gallery: [image30, image29, image31],
      features: [
        t.project7Feature1 || 'Feature 1',
        t.project7Feature2 || 'Feature 2',
        t.project7Feature3 || 'Feature 3'
      ]
    },
    {
      id: 8,
      slug: 'sports-club-project',
      title: t.project8Title,
      description: t.project8Description,
      details: t.project8Details,
      image: image130,
      area: '2,000+ m²',
      cost: language === 'en' ? '2.6+ Million' : '٢.٦+ مليون',
      gallery: [image130, image121, image126],
      features: [
        t.project8Feature1 || 'Feature 1',
        t.project8Feature2 || 'Feature 2',
        t.project8Feature3 || 'Feature 3'
      ]
    },
    {
      id: 9,
      slug: 'sports-track-project',
      title: t.project9Title,
      description: t.project9Description,
      details: t.project9Details,
      image: image39,
      area: '12,500 m²',
      cost: language === 'en' ? '4.2+ Million' : '٤.٢+ مليون',
      gallery: [image39, image42, image43],
      features: [
        t.project9Feature1 || 'Feature 1',
        t.project9Feature2 || 'Feature 2',
        t.project9Feature3 || 'Feature 3'
      ]
    },
    {
      id: 10,
      slug: 'al-sharqi-avenue-project',
      title: t.project10Title,
      description: t.project10Description,
      details: t.project10Details,
      image: image44,
      area: '5,100+ m²',
      cost: language === 'en' ? '5+ Million' : '٥+ مليون',
      gallery: [image44, image45],
      features: [
        t.project10Feature1 || 'Feature 1',
        t.project10Feature2 || 'Feature 2',
        t.project10Feature3 || 'Feature 3'
      ]
    },
    {
      id: 11,
      slug: 'al-awali-makkah-project',
      title: t.project11Title,
      description: t.project11Description,
      details: t.project11Details,
      image: image49,
      area: '46,650 m²',
      cost: language === 'en' ? '9+ Million' : '٩+ مليون',
      gallery: [image49, image50, image51],
      features: [
        t.project11Feature1 || 'Feature 1',
        t.project11Feature2 || 'Feature 2',
        t.project11Feature3 || 'Feature 3'
      ]
    },
    {
      id: 12,
      slug: 'specialized-medical-clinics',
      title: t.project12Title,
      description: t.project12Description,
      details: t.project12Details,
      image: image55,
      area: '2,000+ m²',
      cost: language === 'en' ? '2.6+ Million' : '٢.٦+ مليون',
      gallery: [image55, image56, image57, image58],
      features: [
        t.project12Feature1 || 'Feature 1',
        t.project12Feature2 || 'Feature 2',
        t.project12Feature3 || 'Feature 3'
      ]
    },
    {
      id: 13,
      slug: 'sharafat-park-al-khobar',
      title: t.project13Title,
      description: t.project13Description,
      details: t.project13Details,
      image: image52,
      area: '550,000+ m²',
      cost: language === 'en' ? '20+ Million' : '٢٠+ مليون',
      gallery: [image52, image53, image54],
      features: [
        t.project13Feature1 || 'Feature 1',
        t.project13Feature2 || 'Feature 2',
        t.project13Feature3 || 'Feature 3'
      ]
    },
    {
      id: 14,
      slug: 'justice-training-center',
      title: t.project14Title,
      description: t.project14Description,
      details: t.project14Details,
      image: image35adli,
      area: '4,850+ m²',
      cost: language === 'en' ? '5.79+ Million' : '٥.٧٩+ مليون',
      gallery: [image35adli, image37adli, image38adli],
      features: [
        t.project14Feature1 || 'Feature 1',
        t.project14Feature2 || 'Feature 2',
        t.project14Feature3 || 'Feature 3'
      ]
    },
    {
      id: 15,
      slug: 'office-projects',
      title: t.project15Title,
      description: t.project15Description,
      details: t.project15Details,
      image: imageAdmin2,
      area: '22,000+ m²',
      cost: language === 'en' ? '38+ Million' : '٣٨+ مليون',
      gallery: [imageAdmin2, imageAdmin],
      features: [
        t.project15Feature1 || 'Feature 1',
        t.project15Feature2 || 'Feature 2',
        t.project15Feature3 || 'Feature 3'
      ]
    },
    {
      id: 16,
      slug: 'princess-abeer-complex',
      title: t.project16Title,
      description: t.project16Description,
      details: t.project16Details,
      image: image60,
      area: '2,200+ m²',
      cost: language === 'en' ? '9+ Million' : '٩+ مليون',
      gallery: [image60, image59, image01],
      features: [
        t.project16Feature1 || 'Feature 1',
        t.project16Feature2 || 'Feature 2',
        t.project16Feature3 || 'Feature 3'
      ]
    },
    {
      id: 17,
      slug: 'prophets-mosque-housing-renovation',
      title: t.project17Title,
      description: t.project17Description,
      details: t.project17Details,
      image: image47,
      area: '2,600+ m²',
      gallery: [image47, image48, image46],
      features: [
        t.project17Feature1 || 'Feature 1',
        t.project17Feature3 || 'Feature 3',
        t.project17Feature4 || 'Feature 4',
        t.project17Feature5 || 'Feature 5'
      ]
    },
  ];

  useEffect(() => {
    // Find project by slug OR ID (for backward compatibility if needed, though we switched routes)
    const selectedProject = projects.find(p => p.slug === slug || p.id === parseInt(slug));
    if (selectedProject) {
      setProject(selectedProject);
      setCurrentImageIndex(0);
    } else {
      // Redirect to 404 or home if project not found
      navigate(`/${language}`);
    }
    setLoading(false);
  }, [slug, navigate]);

  if (loading) {
    return <div className="project-details-loading">Loading...</div>;
  }

  if (!project) {
    return null;
  }

  return (
    <div className="project-details">
      <div className="project-details__container">
        <button
          onClick={() => navigate(-1)}
          className="project-details__back-button"
          style={{ flexDirection: language === 'ar' ? 'row-reverse' : 'row' }}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <span>{t.backToProjects || 'Back'}</span>
        </button>

        <div className="project-details__header">
          <h1 className="project-details__title">{project.title}</h1>
        </div>

        <div className="project-details__content">
          {/* Gallery Carousel Section */}
          {project.gallery && project.gallery.length > 0 && (
            <div className="project-details__carousel">
              <div
                className="carousel-container"
                onTouchStart={onTouchStart}
                onTouchMove={onTouchMove}
                onTouchEnd={onTouchEnd}
              >
                <button className="carousel-button prev" onClick={prevImage} aria-label="Previous image">
                  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3">
                    <path d="M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z" />
                  </svg>
                </button>

                <div className="carousel-image-wrapper">
                  <img
                    src={project.gallery[currentImageIndex]}
                    alt={`${project.title} - Image ${currentImageIndex + 1}`}
                    className={`carousel-image ${(project.slug === 'al-nada-sharafat' && currentImageIndex === 1) || (project.slug === 'starta-villa-project' && currentImageIndex === 2)
                      ? 'zoomed-out'
                      : ''
                      }`}
                  />
                </div>

                <button className="carousel-button next" onClick={nextImage} aria-label="Next image">
                  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3">
                    <path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z" />
                  </svg>
                </button>
              </div>
              <div className="carousel-indicators">
                {project.gallery.map((_, index) => (
                  <span
                    key={index}
                    className={`indicator ${index === currentImageIndex ? 'active' : ''}`}
                    onClick={() => setCurrentImageIndex(index)}
                  />
                ))}
              </div>
            </div>
          )}

          <div className="project-details__info">
            <p className="project-details__description">{project.details}</p>

            {/* Project Stats (Area & Cost) */}
            {(project.area || project.cost) && (
              <div className="project-details__stats">
                {project.area && (
                  <div className="project-stat-item">
                    <span className="project-stat-label">{t.projectAreaLabel || 'Project Area'}:</span>
                    <span className="project-stat-value" dir="ltr">{project.area}</span>
                  </div>
                )}
                {project.cost && (
                  <div className="project-stat-item">
                    <span className="project-stat-label">{t.projectCostLabel || 'Project Cost'}:</span>
                    <div className="project-stat-value-row" style={{ display: 'flex', alignItems: 'center', gap: '4px', color: '#D62D53' }}>
                      <span className="project-stat-value" style={{ color: 'inherit' }}>{project.cost}</span>
                      <SaudiRiyalIcon width={24} height={24} />
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectDetails;
